export default __webpack_public_path__ + "static/media/class_logo-icon.6e216af3.svg";